export const selectUsers = (state) => state.users.all || [];
export const selectCurrentUser = (state) => state.users?.current || null;
export const selectIsLoading = (state) => state.users.isLoading;
export const selectSelectedUser = (state) => state.users?.selectedUser || null;
